import { combineReducers } from 'redux'
//import birds from './birds.reducers'
//import cityListing from './city.reducers'
import userDetails from './user.reducers'

export default combineReducers({
	// birds,
	// cityListing,
	userDetails
})